import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "content" ]
  toggle(e) {
    e.preventDefault();
    const opened = this.contentTarget.classList.toggle('table-is-opened')
    this.element.classList.toggle('is-open', opened)
  }
}
